module.exports=[{value:"C",label:"Célibataire"},{value:"D",label:"Divorcé(e)"},{value:"M",label:"Marié(e)"},{value:"V",label:"Veuf(ve)"}];